export interface TimeStamp {
  createdAt: string
  updatedAt: string
}

export function isTimeStamp(item: unknown): item is TimeStamp {
  return Boolean((item as TimeStamp)?.createdAt && (item as TimeStamp)?.updatedAt)
}
